import { createStyles } from "@material-ui/core";
export var styles = function (_a) {
    var spacing = _a.spacing;
    return createStyles({
        root: {
            fontSmoothing: "antialiased",
            marginTop: spacing(3)
        }
    });
};
